"use client";
import { useRef as o, useState as u, useEffect as f } from "react";
function z() {
  const e = o(null), [n, r] = u({ width: 0, height: 0 });
  return f(() => {
    if (!e.current) return;
    const t = new ResizeObserver(([s]) => {
      const { width: i, height: c } = s.contentRect;
      r({ width: i, height: c });
    });
    return t.observe(e.current), () => {
      t.disconnect();
    };
  }, [e]), [e, n];
}
export {
  z as useContainerSize
};
